<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Schedule Next Session'"
    :submit-button-text="'SCHEDULE'"
    :reset-modal="resetModal"
    :submit-modal="setNextSessionDate"
    :modal-error="setError"
    :modal-error-text="setErrorText"
    :force-action="showActions"
  >
    <div v-if="showActions">
      <b-row>
        <b-col>
          <div class="tsny_text-mid mb-3">
            Do you know when your next session will be?
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button class="tsny_button mr-3" @click="showActions = false">
            Yes
          </b-button>
          <b-button
            class="tsny_button tsny_button-cancel"
            @click="clearNextSessionDate"
          >
            No
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div v-if="!showActions">
      <b-row class="mb-3"
        ><b-col>
          <b-checkbox
            class="tsny_checkbox tsny_text-mid"
            v-model="clearNextSession"
            >We don't have a date for our next session</b-checkbox
          >
        </b-col></b-row
      >
      <b-row>
        <b-col>
          <label class="tsny_field_header-text">Session Date</label>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col>
          <b-form-input
            type="date"
            class="tsny_input"
            v-model="date"
            :disabled="clearNextSession"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col
          ><label class="tsny_field_header-text">Session Start</label
          ><i
            class="ml-1 text-dark fas fa-info-circle"
            v-b-tooltip.hover
            title="Field optional, can be set later. Disabled without session date"
        /></b-col>
        <b-col
          ><label class="tsny_field_header-text">Session End</label
          ><i
            class="ml-1 text-dark fas fa-info-circle"
            v-b-tooltip.hover
            title="Field optional, can be set later. Disabled without session date"
        /></b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col
          ><b-form-input
            type="time"
            class="tsny_input"
            v-model="startTime"
            :disabled="timeDisabled"
        /></b-col>
        <b-col
          ><b-form-input
            type="time"
            class="tsny_input"
            v-model="endTime"
            :disabled="timeDisabled"
        /></b-col>
      </b-row>
    </div>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../TsnyModal";
import CourseRelationshipRestService from "../../services/rest/services/CourseRelationshipRestService";
import EventBus from "../../services/eventBus/EventBus";
import EventConstants from "../../services/eventBus/EventConstants";
export default {
  name: "SetNextSessionDateModal",
  components: { TsnyModal },
  props: {
    course: {
      type: Object,
      default: null
    }
  },
  computed: {
    timeDisabled() {
      return this.clearNextSession || !this.date;
    }
  },
  data: function() {
    return {
      modalId: "setNextSessionDateModal",
      showActions: null,
      clearError: null,
      clearNextSession: null,
      date: null,
      startTime: null,
      endTime: null,
      setError: null,
      setErrorText: "An error occurred scheduling your next session"
    };
  },
  mounted: function() {
    EventBus.$on(EventConstants.EVENTS.SESSION_REPORT_CREATED, () => {
      this.showActions = true;
      this.$bvModal.show(this.modalId);
    });
  },
  destroyed() {
    EventBus.$off(EventConstants.EVENTS.SESSION_REPORT_CREATED);
  },
  methods: {
    clearNextSessionDate: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this;
      $comp.clearError = false;

      return CourseRelationshipRestService.setNextSessionDate(
        $comp.course._id,
        true
      )
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          $comp.clearError = true;
          console.log(err);
        });
    },
    setNextSessionDate: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this;
      $comp.setError = false;

      return CourseRelationshipRestService.setNextSessionDate(
        $comp.course._id,
        $comp.clearNextSession,
        $comp.date,
        $comp.startTime,
        $comp.endTime
      )
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          $comp.setError = true;
          console.log(err);
        });
    },
    resetModal: function() {
      this.showActions = null;
      this.date = this.course.nextSessionDate;
      this.startTime = this.course.nextSessionStartTime;
      this.endTime = this.course.nextSessionEndTime;
      this.clearError = null;
      this.setError = null;
    }
  }
};
</script>

<style scoped>
.tsny_checkbox input {
  border-radius: 0;
  border: 1px solid #9d9d9d;
}
</style>
